import React from 'react'
import { signUpBtn } from "../../Markup"

const pageData = [
  {
    type: "Center",
    class: "white-background only-content sm-space-below sm-space-above",
    title: {
      class: "large-title medium-purple",
      text: "Enter your email to sign up"
    },
    paragraph: null,
    centerAction: {
      type: "signup-btn",
      ...signUpBtn
    },
    submittedText: {
      title: {
        class: "medium-title medium-purple",
        text: "You've signed up for the private beta."
      },
      paragraph: [<p className="dark-purple-text small-title center-text">To make sure developers have a great experience (and performance), we're gradually letting people in and we'll email you as soon as we can.</p>]
    }
  },
  {
    type: "Form",
    submitLink: "https://ops-corpsite.builtwithdark.com/submit-beta-signup",
    class: "dark-purple-background white-text",
    showBtn: {
      class: "small-title MankSans-Medium white-text",
      text: "Send"
    },
    title: {
      text: "Need to get started now?",
      class: "large-title"
    },
    paragraph: 
      {
        text: "We are working to open Dark to many more developers. We might give you access immediately if your project is well-scoped, and you're ready to work on it right away."
      },
    formFields: [
      {
        inputName: "name",
        title: {
          class: "small-title bold",
          text: "What's your full name?",
        },
        input: {
          singleLine: true,
          class: "extra-short"
        },
        validation: {
          reqLength: 1,
          errText: "Field required"
        }
      },
      {
        inputName: "project",
        title: {
          class: "small-title bold",
          text: "Tell us about your project: what will it do, and who will use it? ",
        },
        input: {
          class: "long"
        },
        validation: {
          reqLength: 1,
          errText: "Field required"
        }
      },
      {
        inputName: "frontend",
        title: {
          class: "small-title bold",
          text: "What technology are you using for your frontend?",
        },
        input: {
          class: ""
        },
        validation: {
          reqLength: 1,
          errText: "Field required"
        }
      },
      {
        inputName: "external",
        title: {
          class: "small-title bold",
          text: "What external APIs and/or libraries will you need access to?",
        },
        input: {
          class: ""
        },
        validation: {
          reqLength: 1,
          errText: "Field required"
        }
      },
      {
        inputName: "username",
        displayName: "username",
        title: {
          class: "small-title bold",
          text: "What username would you like to use?",
        },
        input: {
          singleLine: true,
          class: "extra-short"
        },
      },
    ]
  }

]

export { pageData }
